<script setup>
import { ref, reactive, watch, computed, onMounted } from 'vue'
import { useApi } from '@/composables/useApi'

const props = defineProps({
  isOpen: Boolean,
  itemData: { type: Object, default: null }
})

const emit = defineEmits(['close', 'save'])

const { fetchData: apiFetch } = useApi()

const initialForm = {
  id: null,
  name: '',
  email: '',
  phone: '',
  password: ''
}

const formData = reactive({ ...initialForm })

const isEdit = computed(() => !!props.itemData && !!props.itemData.id)

// Reset / populate form khi mở/đóng
watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    if (props.itemData) {
      Object.keys(initialForm).forEach(key => {
        formData[key] = props.itemData[key] !== undefined ? props.itemData[key] : initialForm[key]
      })
    } else {
      Object.keys(initialForm).forEach(key => {
        formData[key] = initialForm[key]
      })
    }
  } else {
    // Đóng modal → clear form
    Object.keys(initialForm).forEach(key => {
      formData[key] = initialForm[key]
    })
  }
}, { immediate: true })

const closeForm = () => {
  emit('close')
}

const handleSubmit = () => {
  const submitData = {}
  Object.keys(initialForm).forEach(key => {
    if (key !== 'id') submitData[key] = formData[key]
  })
  if (isEdit.value) submitData.id = formData.id
  // Không gửi password rỗng khi edit
  if (isEdit.value && !submitData.password) {
    delete submitData.password
  }
  emit('save', submitData)
}
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-bold m-0">{{ isEdit ? 'Edit User' : 'Add User' }}</h4>
        <button class="btn-close" @click="closeForm"></button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label fw-semibold">Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="formData.name" placeholder="Enter name" required>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold">Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" v-model="formData.email" placeholder="Enter email" required>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold">Phone</label>
          <input type="text" class="form-control" v-model="formData.phone" placeholder="Enter phone">
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold">
            {{ isEdit ? 'New Password' : 'Password' }}
            <span v-if="!isEdit" class="text-danger">*</span>
            <small v-else class="text-muted fw-normal">(để trống nếu không đổi)</small>
          </label>
          <input 
            type="password" 
            class="form-control" 
            v-model="formData.password" 
            placeholder="Enter password"
            :required="!isEdit"
          >
        </div>



        <div class="d-flex gap-2 mt-4">
          <button type="button" class="btn btn-secondary w-100" @click="closeForm">Cancel</button>
          <button type="submit" class="btn btn-primary w-100">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999 !important;
}
.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 420px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  overflow-y: auto;
}
@media (max-width: 576px) {
  .form-sidebar {
    width: 100% !important;
    padding: 20px;
  }
}
@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>